// cspell:ignore googleapi -- the Google client library's error prefix, as the driver reports it
const RPC_ERROR_PREFIX = 'rpc error: code = Unknown desc = ';
const BIG_QUERY_ERROR_PREFIX = 'googleapi: Error 400: ';

/** The backend's own message when a preview runs past its time limit. */
const QUERY_TIMED_OUT = 'The query timed out.';

/** Driver error phrases and the sentence shown for them; the first match wins. */
const SQL_IMPORT_ERRORS: readonly [pattern: RegExp, message: string][] = [
  [/bigquery: constructing client/i, 'Key file contents must be a valid JSON object.'],
  [/no such host/i, 'We could not connect to your database host. Check that your host name is correct and try again.'],
  [
    /connection refused/i,
    'We could not connect to your database on the port you provided. Check that your port is correct and try again.',
  ],
  [/access denied for user/i, 'Access denied for user. Check your connection credentials and try again.'],
  [
    /password authentication failed for user/i,
    'Access denied for user. Check your connection credentials and try again.',
  ],
  [
    /no route to host/i,
    'Your host name could not be resolved. Check that your host name and port are correct and try again.',
  ],
  [/unknown database/i, 'Your database could not be found. Check that your database name is correct and try again.'],
  [
    /database.*does not exist/i,
    'Your database could not be found. Check that your database name is correct and try again.',
  ],
  [
    /table.*doesn't exist/i,
    "The table you're trying to query from doesn't exist. Check your table name and try again.",
  ],
  [/SSL off/i, 'We could not connect to your database host. Check your SSL connection settings and try again.'],
  [/eof/i, 'Your query returned no rows.'],
];

/**
 * A database driver's error as a sentence for the customer, or the raw text without its RPC
 * wrapping. Shared by the connection form (a failed save) and the query editor (a failed preview).
 */
export function transformSqlImportError(detail: string): string {
  const match = SQL_IMPORT_ERRORS.find(([pattern]) => pattern.test(detail));
  if (match != null) {
    return match[1];
  }
  return detail.replace(RPC_ERROR_PREFIX, '').replace(BIG_QUERY_ERROR_PREFIX, '');
}

/** Whether a preview failed only because it ran past the limit, which the sync itself does not have. */
export function isQueryTimedOutError(error: string): boolean {
  return error === QUERY_TIMED_OUT;
}
